import GenericAction from '@Actions/generic-action';
import { Actions } from '@Context/common/general/context';
import { AnalyticsEvents } from '@Enums';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
export default class SendResetCode extends GenericAction {
  runAction() {
    this._disableLoaders = true;
    const Action = async () => {
      try {
        const response = await sendPasswordResetEmail(getAuth(), this._payload.email)
        this._state.auth.events.resetCodeSent.emit(response);
        // Send analytics event
        this._dispatch({
          type: Actions.AppActions.AnalyticsEvent,
          payload: { 
            type: AnalyticsEvents.user_password_reset_requested
          }
        });
        super.onSuccess(response);
        return Promise.resolve(response);
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}
